export function decodeId(id) {
  return atob(id).split(':')[1]
}

export function encodeId(type, id) {
  return btoa(`${type}:${id}`)
}